import React from 'react';
import { DataGrid } from '../../common/datagrid/ResponsiveDataGrid';
import CustomToolbar from '../../common/datagrid/CustomToolbar';
import CustomLoadingOverlay from '../../common/datagrid/CustomLoadingOverlay';

const RecordLicenseList = ({
  apiRef,
  columns,
  rows,
  error,
  loading,
  handleRowEditStart,
  handleRowEditStop,
  handleCellFocusOut,
  columnVisibilityModel
}) => {
  return (
    <div style={{ display: 'flex', height: '300px' }}>
      <div style={{ flexGrow: 1 }}>
        <DataGrid
          apiRef={apiRef}
          rows={rows ? rows : []}
          columns={columns}
          components={{
            Toolbar: CustomToolbar,
            LoadingOverlay: CustomLoadingOverlay,
          }}
          componentsProps={{
            toolbar: { fileName: '개인별 자격증' },
          }}
          loading={loading}
          editMode="row"
          onRowEditStart={handleRowEditStart}
          onRowEditStop={handleRowEditStop}
          onCellFocusOut={handleCellFocusOut}
          initialState={{ pinnedColumns: { right: ['actions'] } }}
          columnVisibilityModel={columnVisibilityModel? columnVisibilityModel: []}
        />
      </div>
    </div>
  );
};

export default RecordLicenseList;
